// extracted by mini-css-extract-plugin
export default {"container":"order_container__tJzuY","row":"order_row__D0Uah","alignCenter":"order_alignCenter__XlGBQ","col":"order_col__RIjnH"};